import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Header } from '~/components';
import { QueryParamsProvider } from '~/contexts/QueryContext';
import {
  Acionamento,
  AcionamentoExpirado,
  Finalizado,
  Loading,
  NotFound,
  ValorExcedente,
} from '~/pages';

import { PATHS } from './paths';

export default function Routes() {
  return (
    <>
      <Switch>
        <QueryParamsProvider>
          <Header />
          <Route component={Loading} path={PATHS.loading} exact />
          <Route component={Acionamento} path={PATHS.acionamento} exact />
          <Route
            component={(...props) => <Finalizado {...props} typeFinishing={0} />}
            path={PATHS.acionamento_finalizado}
          />
          <Route component={AcionamentoExpirado} path={PATHS.acionamento_expirado} />
          <Route component={ValorExcedente} path={PATHS.valor_excedente} exact />
          <Route
            component={(...props) => <Finalizado {...props} typeFinishing={1} />}
            path={PATHS.valor_excedente_finalizado}
          />
          <Route component={NotFound} path={PATHS.notfound} exact />
        </QueryParamsProvider>
      </Switch>
      <Redirect to={PATHS.loading} />
    </>
  );
}
